import { render, staticRenderFns } from "./ProductOverflows.vue?vue&type=template&id=70cd4cc8&"
import script from "./ProductOverflows.vue?vue&type=script&lang=js&"
export * from "./ProductOverflows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports